module.exports = __webpack_public_path__ + "img/shot_bigtx112502.320b7d9d.png";